"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const common_1 = require("../utils/common");
const QrCodeDataService_1 = __importDefault(require("./QrCodeDataService"));
const CryptoService_1 = __importDefault(require("./CryptoService"));
const GET_CONTENT_PATH = "/ipfs";
class IPFSDataRetriever {
    constructor(ipfsUrl) {
        this.ipfsUrl = ipfsUrl;
    }
    getDecodedContent(contentData, ipfsVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            const rawContent = yield this.getRawContent(contentData.cid, contentData.head, ipfsVersion);
            return this.decryptContent(rawContent, contentData.key, ipfsVersion);
        });
    }
    getRawContent(cid, head, ipfsVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            let assembledData;
            if (cid) {
                let ipfsFileContent;
                if (ipfsVersion === undefined) {
                    const response = yield (0, axios_1.default)({
                        url: `${this.ipfsUrl}${GET_CONTENT_PATH}/${cid}`,
                        method: "GET",
                    });
                    ipfsFileContent = (0, common_1.base64ToArrayBuffer)(response.data);
                }
                else if (ipfsVersion === "v2") {
                    const result = yield axios_1.default.get(`${this.ipfsUrl}${GET_CONTENT_PATH}/${cid}`, { responseType: "arraybuffer" });
                    ipfsFileContent = Buffer.from(result.data);
                }
                else {
                    throw new Error("Unknown qrcode ipfs version");
                }
                assembledData = QrCodeDataService_1.default.assembleQrCodeData((0, common_1.base64ToArrayBuffer)(head), ipfsFileContent);
            }
            else {
                assembledData = (0, common_1.base64ToArrayBuffer)(head);
            }
            return assembledData;
        });
    }
    decryptContent(content, decryptionKey, ipfsVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            const { key, data: iv } = QrCodeDataService_1.default.decodeKeyDataPair(decryptionKey);
            const decryptedZip = yield CryptoService_1.default.decryptAESGCM(content, (0, common_1.base64ToArrayBuffer)(key), (0, common_1.base64ToArrayBuffer)(iv), true);
            if (ipfsVersion === undefined) {
                const decodedZip = new TextDecoder().decode(decryptedZip);
                return (0, common_1.decompressData)(decodedZip);
            }
            const decompressed = (0, common_1.decompressData)(decryptedZip);
            return decompressed;
        });
    }
}
exports.default = IPFSDataRetriever;
